<template>
  <component
    :is="isSortable ? Reorder.Group : tag"
    v-model:values="order"
    class="list-standard"
    :axis="isSortable ? (horizontal ? 'x' : 'y') : null"
    :as="isSortable ? tag : null"
    :class="listClasses"
    :role="role"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed, provide } from 'vue'
import { cx } from '@/helpers'
import { Reorder } from 'motion-v'

defineOptions({ name: 'List' })

const emit = defineEmits(['update:order'])
const props = defineProps({
  tag: { type: String, default: 'div' },
  bordered: { type: Boolean, default: false },
  dense: { type: Boolean, default: false },
  separator: { type: Boolean, default: false },
  padding: { type: Boolean, default: false },
  horizontal: { type: Boolean, default: false },
  order: { type: Array, default: () => [] },
  dragHandle: { type: Boolean, default: false }
})

const isSortable = computed(() => !!props.order.length)
const role = computed(() => ['ul', 'ol'].includes(props.tag) ? null : 'list')
const listClasses = computed(() => cx(
  props.bordered && 'is-bordered',
  props.dense && 'is-dense',
  props.separator && 'is-separator',
  props.padding && 'is-padding',
  isSortable.value && 'is-sortable'
))
const order = computed({
  get: () => props.order,
  set: v => emit('update:order', v)
})

provide('isDense', computed(() => props.dense))
provide('isSortable', computed(() => isSortable.value))
provide('hasDragHandle', computed(() => props.dragHandle))
</script>

<style scoped>
@reference "#app-styles.css";

.list-standard {
  &.is-bordered {
    @apply rounded-lg overflow-hidden;
    @apply border edge-base;
  }
  &.is-padding { @apply py-2; }
  &.is-separator :deep(.list-item-standard + .list-item-standard) { @apply border-t edge-base; }
}
</style>
